import { render, staticRenderFns } from "./grademanage.vue?vue&type=template&id=5d5adb83&"
import script from "./grademanage.vue?vue&type=script&lang=js&"
export * from "./grademanage.vue?vue&type=script&lang=js&"
import style0 from "./grademanage.vue?vue&type=style&index=0&id=5d5adb83&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports